import React from "react";
import {
  Actions,
  Bar,
  CloseBtn,
  CompareBtn,
  Subtitle,
  TextCol,
  Title,
} from "./Styles";

interface CompareToastProps {
  visible: boolean;
  selectedCount: number;
  totalCount?: number;
  compareButtonLabel?: string;
  toastSubtitle?: string;
  showSubtitle?: boolean;
  onCompare: () => void;
  onClose: () => void;
  compareDisabled?: boolean;
}

export const CompareToast = ({
  visible,
  selectedCount,
  totalCount = 2,
  compareButtonLabel = "Compare now",
  toastSubtitle,
  showSubtitle,
  onCompare,
  onClose,
  compareDisabled,
}: CompareToastProps) => {
  if (!visible) return null;

  return (
    <Bar role="status">
      <TextCol>
        <Title>
          {selectedCount}/{totalCount} plans selected
        </Title>
        {showSubtitle && toastSubtitle ? (
          <Subtitle>{toastSubtitle}</Subtitle>
        ) : null}
      </TextCol>
      <Actions>
        <CompareBtn
          type="button"
          $disabled={compareDisabled}
          disabled={compareDisabled}
          onClick={onCompare}
        >
          {compareButtonLabel}
        </CompareBtn>
        <CloseBtn type="button" onClick={onClose} aria-label="Dismiss">
          ×
        </CloseBtn>
      </Actions>
    </Bar>
  );
};
